export default __webpack_public_path__ + "13973f58901165dfafad0ce206d03b36.svg";